import {
	api_methods
} from '../../service/loadData'
import Vue from 'vue'
import util from '@/config/util'
let systemError = {msg:'系统异常，请稍后重试',code:-1};
import {
	SETMETTINGSTORES
} from './mutation-types.js'

export default {
	async getMeetingRoomsAction({ commit,state,getters},params) {
		let response = await api_methods.getMeetingRooms(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getMeetingRoomAction({ commit,state,getters},params) {
		let response = await api_methods.getMeetingRooms(getters.getAccessToken,getters.getVipNo)
		if (response?.response?.code == 1) {
			return response.data.value.filter(item=>item.ID == params.roomId)[0]
		}
		return {}
	},
	async getMeetingDurationsAction({ commit,state,getters},params) {
		let response = await api_methods.getMeetingDurations(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async postReservationRoomsAction({ commit,state,getters},params) {
		let response = await api_methods.postReservationRooms(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return -1
	},
	async getReservationOrdersAction({commit,state,getters},params) {
		let response = await api_methods.getReservationOrders(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getReservationCalendarAction({ commit,state,getters},params) {
		let response = await api_methods.getReservationCalendar(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getReservationCartAction({ commit,state,getters},params) {
		let response = await api_methods.getReservationCart(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return {}
	},
	async getReservationDetailAction({ commit,state,getters},params) { 
		let response = await api_methods.getReservationDetail(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async postReservationAdditionalAction({ commit,state,getters},params) { 
		let response = await api_methods.postReservationAdditional(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	//判断代缴账户类型
	async postDeterminePaymentuserAction({ commit,state,getters},params){
		let response = await api_methods.postDeterminePaymentuser(getters.getAccessToken,params.VipNo,'')
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return '-1' //，默认找不到
	},
	async postCancelReservationAction({ commit,state,getters},params) { 
		let response = await api_methods.postCancelReservation(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getStoresAction({ commit,state,getters},params) {
		let response = await api_methods.getStores(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			commit(SETMETTINGSTORES,response.data.value)
			return response.data.value
		}
		return []
	},
	async getUserRankAction({commit, state, getters}) {
		let response = await api_methods.getUserRank(getters.getAccessToken,getters.getVipNo)
		if (response?.response.code == 1) {
			return response
		}
		return []
	},
	async getMeetingOrderTimeAction({commit,state,getters},params) {
		let response = await api_methods.getMeetingOrderTime(getters.getAccessToken,getters.getVipNo,params.ParentCode,params.Code)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	// 同订单不同时段预约单独取消
	async postAloneCancelAction({ commit,state,getters},params) { 
		let response = await api_methods.postAloneCancel(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	// 研发中心
	async getRDMeetingRoomsAction({ commit,state,getters}) {
		let response = await api_methods.getRDMeetingRooms(getters.getAccessToken,getters.getVipNo)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async postRDMeetingRoomsAction({ commit,state,getters},params) {
		let response = await api_methods.postRDMeetingRooms(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return ''
	},
	async getRDuserInfoAction({ commit,state,getters},vipno) {
		let response = await api_methods.getRDuserInfo(getters.getAccessToken,vipno)
		if (response?.response?.code == 1 && response.data.value.length) {
			return true
		}
		return false
	},
	async checkRDPermissionsctionAction({getters}){
		let uData = await api_methods.checkRDPermissions(getters.getAccessToken,getters.getVipNo);
		if (uData && uData.response.code == 1) {
			return uData.data.value.Value;
		}
	},
	async postChangeMobileAction({ commit,state,getters},params) {
		let response = await api_methods.postChangeMobile(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return ''
	},
}